import { SITE_EMAIL } from "../../shared/seo/site";

export function Terms() {
  return (
    <main className="prose-page" id="main-content">
      <p className="eyebrow">The short version</p>
      <h1>Terms of use</h1>
      <p className="lede">Play the puzzles, print them, share your results. Do not scrape the site or pass it off as your own.</p>
      <section>
        <span className="section-number">01</span>
        <div>
          <h2>Using the site</h2>
          <p>Nonogram Now is free to use and needs no account. You may play any puzzle, print the sheets, and share your results and screenshots, including publicly.</p>
        </div>
      </section>
      <section>
        <span className="section-number">02</span>
        <div>
          <h2>Puzzles and artwork</h2>
          <p>The puzzle pictures, the site's text, and its code are the work of its author. You may print and copy the puzzle sheets for personal, classroom, or other non-commercial use, and we would rather you did. Republishing the puzzle library as your own, selling it, or using automated tools to bulk-download it is not permitted.</p>
        </div>
      </section>
      <section>
        <span className="section-number">03</span>
        <div>
          <h2>No guarantees</h2>
          <p>This is a side project provided as-is. It may be offline, change, or stop being updated without notice. Progress kept in your browser can be lost by clearing site data, by a browser update, or by a bug — treat a streak as a small pleasure rather than something to protect.</p>
        </div>
      </section>
      <section>
        <span className="section-number">04</span>
        <div>
          <h2>Changes to these terms</h2>
          <p>These terms may change as the site does. The current version is always the one on this page. They were last updated on 5 September 2026; questions go to <a href={`mailto:${SITE_EMAIL}`}>{SITE_EMAIL}</a>.</p>
        </div>
      </section>
    </main>
  );
}
